import { render, staticRenderFns } from "./AppFooterMenu.vue?vue&type=template&id=585f7e25"
import script from "./AppFooterMenu.vue?vue&type=script&lang=js"
export * from "./AppFooterMenu.vue?vue&type=script&lang=js"
import style0 from "./AppFooterMenu.vue?vue&type=style&index=0&id=585f7e25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports